export const galleryImages = [
  {
    id: "g1",
    title: "优雅职场AI美女写真",
    category: "ai美女写真",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20professional%20AI-generated%20beautiful%20Asian%20woman%20in%20modern%20office%20attire%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20warm%20neutral%20tones%2C%20sophisticated%20portrait%20photography%20style%2C%20high%20quality%20digital%20art%2C%20subtle%20makeup%2C%20confident%20expression%2C%20cream%20and%20beige%20color%20palette&width=600&height=800&seq=gallery-01&orientation=portrait",
    tags: ["职场", "优雅", "写真"],
  },
  {
    id: "g2",
    title: "甜美可爱AI美女头像",
    category: "ai美女头像",
    imageUrl: "https://readdy.ai/api/search-image?query=Cute%20sweet%20AI-generated%20beautiful%20young%20Asian%20woman%20portrait%2C%20soft%20pink%20pastel%20background%2C%20natural%20daylight%2C%20gentle%20smile%2C%20fresh%20dewy%20makeup%2C%20floral%20elements%2C%20dreamy%20ethereal%20atmosphere%2C%20high%20quality%20digital%20art%2C%20warm%20soft%20lighting%2C%20feminine%20elegant%20style&width=600&height=800&seq=gallery-02&orientation=portrait",
    tags: ["甜美", "可爱", "头像"],
  },
  {
    id: "g3",
    title: "梦幻夜景AI美女壁纸",
    category: "ai美女壁纸",
    imageUrl: "https://readdy.ai/api/search-image?query=Dreamy%20night%20scene%20AI-generated%20beautiful%20Asian%20woman%20in%20elegant%20dress%2C%20city%20lights%20bokeh%20background%2C%20soft%20glamorous%20lighting%2C%20sophisticated%20evening%20portrait%2C%20warm%20golden%20and%20rose%20tones%2C%20cinematic%20composition%2C%20high%20quality%20digital%20art%2C%20luxurious%20atmosphere&width=600&height=800&seq=gallery-03&orientation=portrait",
    tags: ["梦幻", "夜景", "壁纸"],
  },
  {
    id: "g4",
    title: "清新自然AI虚拟美女",
    category: "ai虚拟美女",
    imageUrl: "https://readdy.ai/api/search-image?query=Fresh%20natural%20AI-generated%20beautiful%20Asian%20woman%20outdoor%20garden%20setting%2C%20sunlight%20through%20leaves%2C%20soft%20natural%20makeup%2C%20flowing%20hair%2C%20white%20airy%20dress%2C%20peaceful%20expression%2C%20warm%20cream%20and%20green%20tones%2C%20high%20quality%20digital%20art%2C%20ethereal%20portrait&width=600&height=800&seq=gallery-04&orientation=portrait",
    tags: ["清新", "自然", "虚拟"],
  },
  {
    id: "g5",
    title: "古典东方AI美女写真",
    category: "ai美女写真",
    imageUrl: "https://readdy.ai/api/search-image?query=Classical%20oriental%20AI-generated%20beautiful%20Asian%20woman%20in%20traditional%20elegant%20attire%2C%20soft%20warm%20lighting%2C%20minimalist%20cream%20background%2C%20delicate%20features%2C%20graceful%20pose%2C%20high%20quality%20digital%20art%2C%20refined%20classical%20portrait%20style%2C%20warm%20beige%20and%20rose%20tones&width=600&height=800&seq=gallery-05&orientation=portrait",
    tags: ["古典", "东方", "写真"],
  },
  {
    id: "g6",
    title: "时尚潮流AI美女头像",
    category: "ai美女头像",
    imageUrl: "https://readdy.ai/api/search-image?query=Fashionable%20trendy%20AI-generated%20beautiful%20Asian%20woman%20portrait%2C%20modern%20street%20style%2C%20soft%20warm%20natural%20light%2C%20confident%20expression%2C%20minimalist%20neutral%20background%2C%20high%20quality%20digital%20art%2C%20editorial%20fashion%20photography%20style%2C%20cream%20and%20beige%20tones&width=600&height=800&seq=gallery-06&orientation=portrait",
    tags: ["时尚", "潮流", "头像"],
  },
  {
    id: "g7",
    title: "唯美花海AI美女壁纸",
    category: "ai美女壁纸",
    imageUrl: "https://readdy.ai/api/search-image?query=Romantic%20flower%20field%20AI-generated%20beautiful%20Asian%20woman%2C%20soft%20pastel%20floral%20background%2C%20golden%20hour%20lighting%2C%20flowing%20dress%2C%20dreamy%20atmosphere%2C%20gentle%20expression%2C%20high%20quality%20digital%20art%2C%20warm%20rose%20and%20cream%20tones%2C%20ethereal%20wallpaper%20style&width=600&height=800&seq=gallery-07&orientation=portrait",
    tags: ["唯美", "花海", "壁纸"],
  },
  {
    id: "g8",
    title: "冷艳高级AI虚拟美女",
    category: "ai虚拟美女",
    imageUrl: "https://readdy.ai/api/search-image?query=Cool%20sophisticated%20AI-generated%20beautiful%20Asian%20woman%20in%20minimalist%20studio%20setting%2C%20clean%20neutral%20background%2C%20high%20fashion%20editorial%20style%2C%20sharp%20lighting%2C%20elegant%20expression%2C%20high%20quality%20digital%20art%2C%20monochrome%20warm%20tones%2C%20modern%20aesthetic&width=600&height=800&seq=gallery-08&orientation=portrait",
    tags: ["冷艳", "高级", "虚拟"],
  },
];